import { render, staticRenderFns } from "./xs_PerformanceStatistics.vue?vue&type=template&id=6f28e8c0"
import script from "./xs_PerformanceStatistics.vue?vue&type=script&lang=js"
export * from "./xs_PerformanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./xs_PerformanceStatistics.vue?vue&type=style&index=0&id=6f28e8c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports